export enum TemplateColumn {
    ORDER_NAME = 'name',
    TMS_NUMBERS = 'tmsParcelNumbers',
    STATE = 'stateID',
    COUNTY = 'countyID',
    SUB_DIVISION = 'subdivision',
    ADDRESS = 'address',
    BOOK_AND_PAGE = 'sections.documents.name'
}

export const getTemplateColumnHeader = (headerLabel: string): TemplateColumn | undefined => {
    switch (headerLabel) {
        case 'Order Name':
            return TemplateColumn.ORDER_NAME;
        case 'TMS/Parcel Numbers':
            return TemplateColumn.TMS_NUMBERS;
        case 'State':
            return TemplateColumn.STATE;
        case 'County':
            return TemplateColumn.COUNTY;
        case 'Subdivision':
            return TemplateColumn.SUB_DIVISION;
        case 'Address':
            return TemplateColumn.ADDRESS;
        case 'Instrument Number (Book and Page)':
            return TemplateColumn.BOOK_AND_PAGE;
        default:
            return undefined;
    }
}
